import { Record, Map } from "immutable"

import {
    toUI as defaultToUI,
    normaliseModel,
    hydrateModel,
    updateChangeModel,
    updateCreateModel,
    idify
} from "../model-utils"
import moment from "moment"

export const ClusterModel = new Record({
    id: "",
    title: "",
    week_starting: moment(),
    time: moment(),
    image_url: "",
    is_user_created: false,
    status: "Active",
    description: "",
    articles: [],
    topics: [],
    concepts: []
})

export function ClusterCreateModel() {
    return Map({
        title: "",
        description: "",
        image_url: "",
        status: "Active",
        is_user_created: true
    })
}

const dateFields = ["time", "week_starting"]
const tagFields = []
export const normalisingFields = ["topics", "concepts", "articles"]
export const hydratingFields = ["topics", "concepts", "knowledge"]

const addRemoveFields = ["topics", "concepts", "articles"]

export const normalise = cluster =>
    normaliseModel(cluster, ...normalisingFields)
export const hydrate = (cluster, ...entityStates) => {
    const normalHydratingFields = ["topics", "concepts"]
    const knowledgeState =
        entityStates[hydratingFields.findIndex(name => name === "knowledge")]
    cluster = {
        ...cluster,
        articles: (cluster.articles || []).map(id => knowledgeState[id])
    }
    return hydrateModel(cluster, normalHydratingFields, entityStates)
}

export const updateClusterChangeModel = (
    name,
    value,
    changeModel,
    workingModel
) => {
    if (name === "articles") {
        return changeModel.set("article_ids", idify(value))
    }
    return updateChangeModel(
        name,
        value,
        changeModel,
        workingModel,
        addRemoveFields
    )
}

export const updateClusterCreateModel = (
    name,
    value,
    createModel,
    workingModel
) => {
    if (name === "articles") {
        return createModel.set("article_ids", idify(value))
    }
    return updateCreateModel(
        name,
        value,
        createModel,
        workingModel,
        addRemoveFields
    )
}

export const toUI = user => defaultToUI(user, dateFields, tagFields)
